import HubOperationSettingVM from '@/view-model/operation-setting/HubOperationSettingVM';
import StoreOperationSettingVM from '@/view-model/operation-setting/StoreOperationSettingVM';
import { whereOperators } from '@/lib/query-parameter/filter';
import { hubService, storeService, } from '@/services';
import OperationSettingHistory from '@/entity/OperationSettingHistory';
import { sortString, vuexEventPathGenerator, } from '@/utils';
import { processType } from '@/constants/operationSetting/option';
import { mutationType } from './mutations';
export const actionType = {
    clearList: 'clearList',
    setOpenHistoryDialog: 'setOpenHistoryDialog',
    setSelectedHub: 'setSelectedHub',
    setSelectedStore: 'setSelectedStore',
    /** watch filterOption을 일으킴 */
    setFilterOption: 'setFilterOption',
    getOperationSettingHistoryList: 'getOperationSettingHistoryList',
    getHubInfo: 'getHubInfo',
    getHubList: 'getHubList',
    getStoreList: 'getStoreList',
    setIsGettingHistoryOnFetching: 'setIsGettingHistoryOnFetching',
    setIsGettingHistoryOnError: 'setIsGettingHistoryOnError',
};
export const operationSettingHistoryActionType = vuexEventPathGenerator(actionType, 'operationSettingHistory');
const action = {
    [actionType.clearList]({ commit }) {
        commit(mutationType.CLEAR_LIST);
    },
    [actionType.setOpenHistoryDialog]({ commit }, isOpen = true) {
        commit(mutationType.SET_OPEN_HISTORY_DIALOG, isOpen);
    },
    [actionType.setSelectedHub]({ commit }, hubId) {
        commit(mutationType.SET_SELECTED_HUB, hubId);
    },
    [actionType.setSelectedStore]({ commit }, storeId) {
        commit(mutationType.SET_SELECTED_STORE, storeId);
    },
    [actionType.setFilterOption]({ commit }, payload) {
        commit(mutationType.SET_FILTER_OPTION, payload);
    },
    async [actionType.getOperationSettingHistoryList]({ state: { selectedHub, selectedStore, filterOption, }, getters, commit, }) {
        const { pageNumber, pageSize } = filterOption;
        const [start, end,] = getters.getterBetweenDateToTimeStamp;
        // 조회 기간
        const filterBetweenDate = {
            field: 'createdAt',
            start,
            end,
        };
        let processTypes = [
            processType.APPLY_CONFIG_SURCHARGE,
            processType.RELEASE_CONFIG_SURCHARGE,
            processType.CHANGE_IRREGULAR_SURCHARGE,
            processType.PAUSE_DELIVERY,
            processType.ON_DELIVERY,
            processType.CHANGE_DELAY_TIME,
        ];
        const filters = [];
        // 허브
        filters.push({
            condition: whereOperators.equals,
            field: 'hubId',
            value: selectedHub,
        });
        // 상점
        if (selectedStore !== 'ALL') {
            filters.push({
                condition: whereOperators.equals,
                field: 'storeId',
                value: selectedStore,
            });
        }
        // 설정유형
        if (filterOption.selectedType !== 'ALL') {
            processTypes = processTypes.filter((val) => val === filterOption.selectedType);
        }
        try {
            const param = {
                hubId: selectedHub,
                pageNumber,
                pageSize,
                betweenDate: filterBetweenDate,
                filters,
                processTypes,
            };
            const data = await hubService.getOperationSettingHistories(param);
            const list = data.list.map((history) => new OperationSettingHistory(history));
            const { paginationData } = data;
            commit(mutationType.GET_OPERATION_SETTING_HISTORY_LIST, {
                list,
                paginationData,
            });
        }
        catch (error) {
            console.log('[getOperationSettingHistoryList]', error);
        }
    },
    [actionType.getHubInfo]({ commit, rootGetters }) {
        commit(mutationType.GET_HUB_LIST, [
            new HubOperationSettingVM(rootGetters['user/hubInfo']),
        ]);
    },
    /**
     * 허브 조회
     */
    async [actionType.getHubList]({ commit }) {
        try {
            const { list } = await hubService.getHubs({
                pageNumber: 1,
                pageSize: 10_000,
                useYn: 'Y',
            });
            const itemList = list.map((_hub) => new HubOperationSettingVM(_hub))
                .sort((a, b) => sortString(a.name, b.name));
            commit(mutationType.GET_HUB_LIST, itemList);
        }
        catch (error) {
            console.log('[getHubList]', error);
            throw error;
        }
    },
    /**
     * 상점 조회
     */
    async [actionType.getStoreList]({ commit, getters }) {
        try {
            const hubId = getters.getterSelectedHub;
            if (!hubId) {
                return;
            }
            const filters = [];
            filters.push({
                condition: whereOperators.equals,
                field: 'hubId',
                value: hubId,
            });
            const { list } = await storeService.getStoreList({
                filters,
            });
            const itemList = list.map((_store) => new StoreOperationSettingVM(_store))
                .sort((a, b) => sortString(a.name, b.name));
            commit(mutationType.GET_STORE_LIST, itemList);
        }
        catch (error) {
            console.log('[getStoreList]', error);
            throw error;
        }
    },
    [actionType.setIsGettingHistoryOnFetching]({ commit }, isFetching) {
        commit(mutationType.SET_IS_GETTING_HISTORY_ON_FETCHING, isFetching);
    },
    [actionType.setIsGettingHistoryOnError]({ commit }, isError) {
        commit(mutationType.SET_IS_GETTING_HISTORY_ON_ERROR, isError);
    },
};
export default action;
